(function () {
  'use strict';

  var NS = '__BNON_SKIN_SCENT_QUIZ__';
  var VERSION = '1.4.0';
  var registry = window[NS] = window[NS] || { version: VERSION, instances: {} };
  registry.instances = registry.instances || {};

  function normalizeResultCode(value) {
    return String(value || '')
      .trim()
      .toUpperCase()
      .replace(/[–—]/g, '-')
      .replace(/\s+/g, '');
  }

  function safeNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : 0;
  }

  function setFocusable(container, enabled) {
    if (!container) return;
    var items = container.querySelectorAll('a, button, input, select, textarea, [tabindex]');
    items.forEach(function (item) {
      if (enabled) {
        if (item.hasAttribute('data-bnon-prev-tabindex')) {
          var prev = item.getAttribute('data-bnon-prev-tabindex');
          if (prev === '') item.removeAttribute('tabindex');
          else item.setAttribute('tabindex', prev);
          item.removeAttribute('data-bnon-prev-tabindex');
        }
      } else {
        if (!item.hasAttribute('data-bnon-prev-tabindex')) {
          item.setAttribute('data-bnon-prev-tabindex', item.getAttribute('tabindex') || '');
        }
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  function Controller(root) {
    this.root = root;
    this.id = root.dataset.sectionId;
    this.language = '';
    this.currentQuestion = 0;
    this.answers = {};
    this.resultCode = '';
    this.questionPanels = [];
    this.panels = [];
    this.emailPanel = null;
    this.resultPanel = null;
    this.stage = root.querySelector('[data-quiz-stage]');
    this.scaleShell = root.querySelector('[data-scale-shell]');
    this.form = null;
    this.destroyed = false;
    this.emailRequestInFlight = false;

    this.boundClick = this.onClick.bind(this);
    this.boundChange = this.onChange.bind(this);
    this.boundSubmit = this.onSubmit.bind(this);
    this.boundKeydown = this.onKeydown.bind(this);
    this.boundResize = this.updateScale.bind(this);
    this.boundDragStart = this.onDragStart.bind(this);
    this.boundSelectStart = this.onSelectStart.bind(this);

    this.resizeObserver = null;
    this.refreshStructure();
    this.init();
  }

  Controller.prototype.refreshStructure = function () {
    /* DOM order is the source of truth. This avoids relying on stale/duplicate
       question indexes after Theme Editor block reordering. */
    this.questionPanels = Array.prototype.slice.call(this.root.querySelectorAll('[data-panel="question"]'));
    this.panels = Array.prototype.slice.call(this.root.querySelectorAll('[data-panel]'));
    this.emailPanel = this.root.querySelector('[data-email-panel], [data-panel="email"]');
    this.resultPanel = this.root.querySelector('[data-result-panel], [data-panel="result"]');
    this.form = this.root.querySelector('.bnon-sq__email-form');
  };

  Controller.prototype.disableNativeDragging = function () {
    this.root.querySelectorAll('img').forEach(function (image) {
      image.draggable = false;
      image.setAttribute('draggable', 'false');
    });
  };

  Controller.prototype.init = function () {
    this.root.dataset.quizControllerVersion = VERSION;

    /* Capture click before theme/app bubble handlers can stop propagation on
       image-based answers. This is especially important for Q3/Q6 cards. */
    this.root.addEventListener('click', this.boundClick, true);
    this.root.addEventListener('change', this.boundChange);
    this.root.addEventListener('input', this.boundChange);
    this.root.addEventListener('submit', this.boundSubmit, true);
    this.root.addEventListener('keydown', this.boundKeydown, true);
    this.root.addEventListener('dragstart', this.boundDragStart, true);
    this.root.addEventListener('selectstart', this.boundSelectStart);

    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(this.boundResize);
      this.resizeObserver.observe(this.root);
      if (this.stage) this.resizeObserver.observe(this.stage);
    } else {
      window.addEventListener('resize', this.boundResize);
    }

    this.disableNativeDragging();
    this.showPanel('language');
    this.updateEmailSubmitState();
    this.updateScale();
  };

  Controller.prototype.destroy = function () {
    if (this.destroyed) return;
    this.destroyed = true;
    this.root.removeEventListener('click', this.boundClick, true);
    this.root.removeEventListener('change', this.boundChange);
    this.root.removeEventListener('input', this.boundChange);
    this.root.removeEventListener('submit', this.boundSubmit, true);
    this.root.removeEventListener('keydown', this.boundKeydown, true);
    this.root.removeEventListener('dragstart', this.boundDragStart, true);
    this.root.removeEventListener('selectstart', this.boundSelectStart);
    if (this.resizeObserver) this.resizeObserver.disconnect();
    else window.removeEventListener('resize', this.boundResize);
    if (this.stage) {
      this.stage.style.position = '';
      this.stage.style.left = '';
      this.stage.style.top = '';
      this.stage.style.transform = '';
    }
    if (this.scaleShell) this.scaleShell.style.height = '';
  };

  Controller.prototype.onDragStart = function (event) {
    event.preventDefault();
  };

  Controller.prototype.onSelectStart = function (event) {
    var target = event.target;
    if (target && target.closest && target.closest('input, textarea, [contenteditable="true"]')) return;
    event.preventDefault();
  };

  Controller.prototype.onClick = function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var languageButton = target.closest('[data-language-choice]');
    if (languageButton && this.root.contains(languageButton)) {
      event.preventDefault();
      this.language = languageButton.dataset.languageChoice || 'en';
      this.currentQuestion = 0;
      this.answers = {};
      this.resultCode = '';
      this.root.dataset.language = this.language;
      if (this.root.querySelector('[data-panel="intro"]')) { this.showPanel('intro'); } else { this.showQuestion(0); }
      return;
    }

    var introStart = target.closest('[data-intro-start]');
    if (introStart && this.root.contains(introStart)) {
      event.preventDefault();
      this.showQuestion(0);
      return;
    }

    var optionButton = target.closest('[data-option]');
    if (optionButton && this.root.contains(optionButton)) {
      event.preventDefault();
      this.handleOptionClick(optionButton);
      return;
    }

    var backButton = target.closest('[data-quiz-back]');
    if (backButton && this.root.contains(backButton)) {
      event.preventDefault();
      this.refreshStructure();
      if (backButton.dataset.quizBack === 'email') {
        this.showQuestion(Math.max(0, this.questionPanels.length - 1));
      } else {
        var currentPanel = backButton.closest('[data-panel="question"]');
        var currentIndex = this.getQuestionIndex(currentPanel);
        if (currentIndex <= 0) this.showPanel(this.root.querySelector('[data-panel="intro"]') ? 'intro' : 'language');
        else this.showQuestion(currentIndex - 1);
      }
      return;
    }

    var emailSubmitButton = target.closest('[data-email-submit]');
    if (emailSubmitButton && this.root.contains(emailSubmitButton)) {
      event.preventDefault();
      event.stopPropagation();
      this.handleEmailSubmit();
      return;
    }

    var skipButton = target.closest('[data-email-skip]');
    if (skipButton && this.root.contains(skipButton)) {
      event.preventDefault();
      this.showResult(this.calculateResultCodeSafe());
      return;
    }

    var restartButton = target.closest('[data-quiz-restart]');
    if (restartButton && this.root.contains(restartButton)) {
      event.preventDefault();
      this.language = '';
      this.currentQuestion = 0;
      this.answers = {};
      this.resultCode = '';
      this.root.dataset.language = '';
      this.root.querySelectorAll('[data-option]').forEach(function (button) {
        button.setAttribute('aria-pressed', 'false');
      });
      if (this.form) this.form.reset();
      this.updateEmailSubmitState();
      this.showPanel('language');
    }
  };

  Controller.prototype.getQuestionIndex = function (panel) {
    if (!panel) return -1;
    this.refreshStructure();
    return this.questionPanels.indexOf(panel);
  };

  Controller.prototype.handleOptionClick = function (optionButton) {
    this.refreshStructure();
    var panel = optionButton.closest('[data-panel="question"]');
    if (!panel) return;

    var qIndex = this.questionPanels.indexOf(panel);
    if (qIndex < 0) return;

    /* Saving an answer must never be able to block screen navigation. */
    try {
      var questionKey = panel.dataset.questionKey || ('q' + qIndex);
      this.answers[questionKey] = {
        optionKey: optionButton.dataset.optionKey || '',
        lotionAxis: String(optionButton.dataset.lotionAxis || '').trim().toUpperCase(),
        a: safeNumber(optionButton.dataset.scoreA),
        b: safeNumber(optionButton.dataset.scoreB),
        c: safeNumber(optionButton.dataset.scoreC),
        d: safeNumber(optionButton.dataset.scoreD)
      };
    } catch (error) {
      console.error('[B&on Skin Scent Quiz] Answer save failed; navigation will continue.', error);
    }

    panel.querySelectorAll('[data-option]').forEach(function (button) {
      button.setAttribute('aria-pressed', button === optionButton ? 'true' : 'false');
    });

    this.currentQuestion = qIndex;

    /* Navigate using the actual next question element. Q6 therefore cannot be
       mistaken for a non-final question because of a stale data index. */
    var nextPanel = this.questionPanels[qIndex + 1] || null;
    if (nextPanel) {
      this.showSpecific(nextPanel);
      this.currentQuestion = qIndex + 1;
      return;
    }

    this.goAfterLastQuestion();
  };

  Controller.prototype.goAfterLastQuestion = function () {
    this.refreshStructure();

    /* Q6 -> Email is intentionally independent of score/result calculation.
       Even malformed result data cannot prevent the Email screen opening. */
    if (this.emailPanel && this.emailPanel.dataset.enabled !== 'false') {
      this.showSpecific(this.emailPanel);
      this.updateEmailSubmitState();
      return;
    }

    this.showResult(this.calculateResultCodeSafe());
  };

  Controller.prototype.onChange = function (event) {
    if (event.target && event.target.matches('[data-consent-check], [data-email-input]')) {
      this.updateEmailSubmitState();
    }
  };

  Controller.prototype.onKeydown = function (event) {
    var target = event.target;
    if (!target || event.key !== 'Enter') return;
    if (!target.matches('[data-email-input]')) return;

    event.preventDefault();
    event.stopPropagation();
    this.handleEmailSubmit();
  };

  Controller.prototype.onSubmit = function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('.bnon-sq__email-form') || !this.root.contains(form)) return;

    /* Capture-phase guard: even if the theme or an app also listens for this
       customer form, native navigation is cancelled before the event reaches
       target/bubble handlers. */
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

    this.form = form;
    this.handleEmailSubmit();
  };

  Controller.prototype.handleEmailSubmit = function () {
    this.refreshStructure();
    if (!this.form) return;

    var email = this.form.querySelector('[data-email-input]');
    var consent = this.form.querySelector('[data-consent-check]');

    if (email && !email.checkValidity()) {
      email.reportValidity();
      return;
    }

    if (consent && consent.required && !consent.checked) {
      consent.reportValidity();
      return;
    }

    var formData = null;
    try { formData = new FormData(this.form); } catch (error) {
      console.warn('[B&on Skin Scent Quiz] Could not build email form data:', error);
    }

    /* UI navigation is synchronous and completely independent of Shopify's
       customer-form response. The page therefore never reloads to Language. */
    this.showResult(this.calculateResultCodeSafe());

    /* When a consent checkbox exists and is optional, an unchecked box means
       no marketing subscription request is sent. */
    var maySubmitMarketing = !consent || consent.checked;
    if (maySubmitMarketing && formData) this.submitEmailInBackground(formData);
  };

  Controller.prototype.submitEmailInBackground = function (formData) {
    if (!this.form || !formData || !('fetch' in window) || this.emailRequestInFlight) return;

    var action = this.form.action;
    var method = (this.form.method || 'post').toUpperCase();
    var self = this;
    this.emailRequestInFlight = true;
    this.updateEmailSubmitState();

    var finish = function () {
      self.emailRequestInFlight = false;
      self.updateEmailSubmitState();
    };

    fetch(action, {
      method: method,
      body: formData,
      credentials: 'same-origin',
      redirect: 'follow',
      headers: { 'Accept': 'text/html' }
    }).then(function (response) {
      if (!response.ok) throw new Error('HTTP ' + response.status);
      finish();
    }).catch(function (error) {
      console.warn('[B&on Skin Scent Quiz] Email background submission failed:', error);
      finish();
    });
  };

  Controller.prototype.showQuestion = function (index) {
    this.refreshStructure();
    var panel = this.questionPanels[index];
    if (!panel) {
      console.warn('[B&on Skin Scent Quiz] Question panel not found:', index);
      return;
    }
    this.currentQuestion = index;
    this.showSpecific(panel);
  };

  Controller.prototype.showPanel = function (type) {
    this.refreshStructure();
    var panel = this.root.querySelector('[data-panel="' + type + '"]');
    if (panel) this.showSpecific(panel);
  };

  Controller.prototype.showSpecific = function (target) {
    if (!target) return;
    this.refreshStructure();

    this.panels.forEach(function (panel) {
      var active = panel === target;
      if (active) {
        panel.hidden = false;
        panel.removeAttribute('hidden');
        panel.classList.add('is-active');
      } else {
        panel.hidden = true;
        panel.setAttribute('hidden', '');
        panel.classList.remove('is-active');
      }
      panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      setFocusable(panel, active);
    });

    this.root.dataset.activePanel = target.dataset.panel || '';
    this.applyLanguage();
    this.disableNativeDragging();
    this.updateScale();
  };

  Controller.prototype.applyLanguage = function () {
    var language = this.language || 'en';
    this.root.querySelectorAll('[data-lang-copy]').forEach(function (node) {
      node.hidden = node.dataset.langCopy !== language;
    });
    this.root.querySelectorAll('[data-lang-placeholder-en]').forEach(function (input) {
      input.placeholder = language === 'ko'
        ? (input.dataset.langPlaceholderKo || input.dataset.langPlaceholderEn || '')
        : (input.dataset.langPlaceholderEn || '');
    });
    this.root.setAttribute('lang', language === 'ko' ? 'ko' : 'en');
    this.formatKrwPrices();
  };

  Controller.prototype.calculateResultCodeSafe = function () {
    try {
      return this.calculateResultCode();
    } catch (error) {
      console.error('[B&on Skin Scent Quiz] Result calculation failed:', error);
      return 'C-F';
    }
  };

  Controller.prototype.calculateResultCode = function () {
    var totals = { A: 0, B: 0, C: 0, D: 0 };
    var lotionAxis = 'F';
    var answers = this.answers || {};

    Object.keys(answers).forEach(function (key) {
      var answer = answers[key] || {};
      totals.A += safeNumber(answer.a);
      totals.B += safeNumber(answer.b);
      totals.C += safeNumber(answer.c);
      totals.D += safeNumber(answer.d);

      var axis = String(answer.lotionAxis || '').trim().toUpperCase();
      if (axis === 'F' || axis === 'V') lotionAxis = axis;
    });

    var priority = ['C', 'B', 'D', 'A'];
    var winner = priority[0];
    priority.forEach(function (type) {
      if (totals[type] > totals[winner]) winner = type;
    });

    return normalizeResultCode(winner + '-' + lotionAxis);
  };

  Controller.prototype.showResult = function (forcedCode) {
    this.refreshStructure();
    if (!this.resultPanel) {
      console.warn('[B&on Skin Scent Quiz] Result screen block is missing.');
      return;
    }

    var code = normalizeResultCode(forcedCode || this.resultCode || this.calculateResultCodeSafe());
    this.resultCode = code;

    /* Open Result screen before inspecting entries. Missing/mismatched entries
       must never make the UI look stuck on Email. */
    this.showSpecific(this.resultPanel);

    var results = Array.prototype.slice.call(this.resultPanel.querySelectorAll('[data-result-code]'));
    if (!results.length) {
      console.warn('[B&on Skin Scent Quiz] No result entries were rendered.');
      return;
    }

    var matched = null;
    results.forEach(function (result) {
      if (!matched && normalizeResultCode(result.dataset.resultCode) === code) matched = result;
    });

    if (!matched) {
      console.warn('[B&on Skin Scent Quiz] No exact result entry matched:', code, '- showing first available result.');
      matched = results[0];
    }

    results.forEach(function (result) {
      var active = result === matched;
      result.hidden = !active;
      if (active) result.removeAttribute('hidden');
      else result.setAttribute('hidden', '');
      result.setAttribute('aria-hidden', active ? 'false' : 'true');
      setFocusable(result, active);
    });

    if (matched) {
      matched.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
    }

    this.applyLanguage();
    this.disableNativeDragging();
    this.updateScale();
  };

  Controller.prototype.updateEmailSubmitState = function () {
    this.refreshStructure();
    if (!this.form) return;

    var submit = this.form.querySelector('[data-email-submit]');
    var email = this.form.querySelector('[data-email-input]');
    var consent = this.form.querySelector('[data-consent-check]');
    if (!submit || !email) return;

    var okay = email.value.trim().length > 0 && email.validity.valid;
    if (consent && consent.required) okay = okay && consent.checked;
    if (this.emailRequestInFlight) okay = false;
    submit.disabled = !okay;
  };

  Controller.prototype.formatKrwPrices = function () {
    var language = this.language || 'en';
    this.root.querySelectorAll('[data-krw-price]').forEach(function (node) {
      if (language !== 'ko') return;
      var value = Number(node.dataset.krwPrice || 0);
      if (!Number.isFinite(value)) return;
      try {
        node.textContent = new Intl.NumberFormat('ko-KR', {
          style: 'currency',
          currency: 'KRW',
          maximumFractionDigits: 0
        }).format(value);
      } catch (error) {
        node.textContent = '₩' + String(Math.round(value)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
    });
  };

  Controller.prototype.updateScale = function () {
    if (!this.stage || !this.scaleShell) return;

    if (window.matchMedia('(max-width: 749px)').matches) {
      this.stage.style.position = '';
      this.stage.style.left = '';
      this.stage.style.top = '';
      this.stage.style.transform = '';
      this.scaleShell.style.height = '';
      return;
    }

    var reference = Number(this.root.dataset.maxWidth || 1400);
    var sensitivity = Number(this.root.dataset.scaleSensitivity || 100) / 100;
    var available = this.scaleShell.clientWidth;
    if (!available || !reference) return;

    var natural = Math.min(1, available / reference);
    var scale = 1 - ((1 - natural) * sensitivity);
    scale = Math.min(1, Math.max(natural, scale));

    this.stage.style.position = 'absolute';
    this.stage.style.left = '50%';
    this.stage.style.top = '0';
    this.stage.style.transform = 'translateX(-50%) scale(' + scale.toFixed(5) + ')';
    this.scaleShell.style.height = Math.ceil(this.stage.scrollHeight * scale) + 'px';
  };

  function initRoot(root) {
    if (!root || !root.dataset.sectionId) return;
    var id = root.dataset.sectionId;
    if (registry.instances[id] && typeof registry.instances[id].destroy === 'function') {
      registry.instances[id].destroy();
    }
    registry.instances[id] = new Controller(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-bnon-skin-scent-quiz]').forEach(initRoot);
  }

  function installGlobalHandlers() {
    /* New versions can cleanly replace global Theme Editor listeners rather
       than stacking multiple runtimes in the same editor session. */
    if (typeof registry.removeGlobalHandlers === 'function') {
      registry.removeGlobalHandlers();
    }

    var onSectionLoad = function (event) {
      initAll(event.target);
    };

    var onSectionUnload = function (event) {
      var root = event.target.querySelector('[data-bnon-skin-scent-quiz]');
      if (!root) return;
      var id = root.dataset.sectionId;
      if (registry.instances[id] && typeof registry.instances[id].destroy === 'function') {
        registry.instances[id].destroy();
        delete registry.instances[id];
      }
    };

    var onBlockSelect = function (event) {
      var block = event.target.closest('[data-bnon-quiz-block]');
      if (!block) return;
      var root = block.closest('[data-bnon-skin-scent-quiz]');
      if (!root) return;
      var controller = registry.instances[root.dataset.sectionId];
      if (!controller) return;
      var panel = block.querySelector('[data-panel]') || block.closest('[data-panel]');
      if (panel) controller.showSpecific(panel);
    };

    document.addEventListener('shopify:section:load', onSectionLoad);
    document.addEventListener('shopify:section:unload', onSectionUnload);
    document.addEventListener('shopify:block:select', onBlockSelect);

    registry.removeGlobalHandlers = function () {
      document.removeEventListener('shopify:section:load', onSectionLoad);
      document.removeEventListener('shopify:section:unload', onSectionUnload);
      document.removeEventListener('shopify:block:select', onBlockSelect);
    };
  }

  registry.version = VERSION;
  installGlobalHandlers();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }
}());
